import { useParams } from 'react-router-dom';
import { Collection } from '@tinct/web-collection';
import { useGetCampaignById, useGetLandingPageLeadFormSubmissions } from '@tinct/core-api';
import { useLeadFormSubmissionsColumns } from '../../shared';

/**
 * Lead-form submissions of the campaign's hosted landing page, newest
 * first. Preview submissions from the studio are real and land here too.
 */
export function LeadsTab() {
  const { id = '' } = useParams<{ id: string }>();
  const columns = useLeadFormSubmissionsColumns();

  const { data: campaign } = useGetCampaignById(
    {
      id,
      fields: {
        id: null,
        landingPageOriginType: null,
        landingPage: { fields: { id: null } },
      },
    },
    { enabled: !!id },
  );

  const landingPageId = campaign?.landingPage?.id ?? null;

  if (!landingPageId) return null;

  return (
    <Collection
      useLocationAsState
      columns={columns}
      useQueryFn={useGetLandingPageLeadFormSubmissions}
      staticParams={{ landingPageId }}
      queryFields={{
        id: null,
        landingPageId: null,
        email: null,
        data: null,
        destination: null,
        forwardStatus: null,
        crmContactId: null,
        forwardError: null,
        sourceUrl: null,
        createdAt: null,
      }}
      emptyState={
        <div className="flex flex-col items-center justify-center gap-1 py-16 text-center">
          <p className="text-sm font-medium text-foreground">No leads yet</p>
          <p className="max-w-sm text-sm text-muted-foreground">
            Submissions from this page&apos;s lead form appear here — including
            test submissions made from the studio preview.
          </p>
        </div>
      }
    />
  );
}
